export default "__VITE_ASSET__DnyH0MGK__"